import * as marietta from '../..';

/**
 * itemMenuカテゴリのクラス
 */
export default class ItemMenuCategories {
  // eslint-disable-next-line no-undef
  timeoutID:NodeJS.Timeout;

  /**
   * コンストラクタ
   */
  constructor() {
    document.getElementById('itemMenuCategories').querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.changeItemMenu);
    });
  }

  /**
   * 表示するメニューの変更
   */
  changeItemMenu = (e:Event) => {
    e.preventDefault();
    // 表示中のダイアログを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();

    // 選択ボタンの解除
    document.getElementById('checkSelectMode').classList.remove('is-active');

    // 表示するメニューのIDを取得
    const targetID = `#itemMenu_${(<HTMLElement>(e.currentTarget)).getAttribute('value')}`;

    clearTimeout(this.timeoutID);
    // 表示しているメニューの有無を判別
    if (marietta.webcad.WebCADGlobal.itemMenu.currentMenuID) {
      // アイテムメニューを全て非表示に
      marietta.webcad.WebCADGlobal.itemMenu.hideAll();

      // 対象のメニューを表示(アニメーション)
      this.timeoutID = setTimeout(() => {
        marietta.webcad.WebCADGlobal.itemMenu.show(targetID);
      }, 500);
    } else {
      marietta.webcad.WebCADGlobal.itemMenu.show(targetID);
    }
  }

  /**
   * ボタンの有効・無効設定
   */
  updateItemMenuButtons = () => {
    this.showHideMenuButtons();
    // 敷地データがなければ、エクステリア無効
    if (marietta.webcad.WebCADGlobal.hasSiteInput()) {
      (<HTMLInputElement>document.querySelector('#select6')).disabled = false;
      document.querySelector('#select6 + label').classList.remove('notAllowed');
    } else {
      (<HTMLInputElement>document.querySelector('#select6')).disabled = true;
      document.querySelector('#select6 + label').classList.add('notAllowed');
    }

    // 敷地データがなければ、エクステリア無効
    if (marietta.webcad.WebCADGlobal.hasRoomInput()) {
      (<HTMLInputElement>document.querySelector('#select3')).disabled = false;
      document.querySelector('#select3 + label').classList.remove('notAllowed');
      (<HTMLInputElement>document.querySelector('#select4')).disabled = false;
      document.querySelector('#select4 + label').classList.remove('notAllowed');
      (<HTMLInputElement>document.querySelector('#select5')).disabled = false;
      document.querySelector('#select5 + label').classList.remove('notAllowed');
      if ((<HTMLInputElement>document.querySelector('#select7')) !== null) {
        (<HTMLInputElement>document.querySelector('#select7')).disabled = false;
        document.querySelector('#select7 + label').classList.remove('notAllowed');
      }
    } else {
      (<HTMLInputElement>document.querySelector('#select3')).disabled = true;
      document.querySelector('#select3 + label').classList.add('notAllowed');
      (<HTMLInputElement>document.querySelector('#select4')).disabled = true;
      document.querySelector('#select4 + label').classList.add('notAllowed');
      (<HTMLInputElement>document.querySelector('#select5')).disabled = true;
      document.querySelector('#select5 + label').classList.add('notAllowed');
      if ((<HTMLInputElement>document.querySelector('#select7')) !== null) {
        (<HTMLInputElement>document.querySelector('#select7')).disabled = true;
        document.querySelector('#select7 + label').classList.add('notAllowed');
      }
    }

  }

  /**
   *メニュー表示/非表示
   */
  showHideMenuButtons = () => {
    // 建物の種類に基づいてメニューを非表示にする
    const furnitureIcon = document.querySelector('#itemMenuCategories label[for="select5"] .icon'); // 家具アイコンの色変更 灰 ⇔ 白
    const drawIcon = document.querySelector('#itemMenuCategories label[for="select8"] .icon'); // 汎用作図アイコンの色変更 灰 ⇔ 白
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === 0) {
      document.querySelector('.for2D .leftMenuCategories').classList.remove('mansionMode');
      if ((<HTMLInputElement>document.querySelector('#select7'))) {
        (<HTMLInputElement>document.querySelector('#select7')).classList.remove('isHidden');
        document.querySelector('#select7 + label').classList.remove('isHidden');
      }
      (<HTMLInputElement>document.querySelector('#select6')).classList.remove('isHidden');
      document.querySelector('#select6 + label').classList.remove('isHidden');
      (<HTMLInputElement>document.querySelector('#select2')).classList.remove('isHidden');
      document.querySelector('#select2 + label').classList.remove('isHidden');
      (<HTMLInputElement>document.querySelector('#select0')).classList.remove('isHidden');
      document.querySelector('#select0 + label').classList.remove('isHidden');

      furnitureIcon.classList.remove('icon-furniture_mansion');
      furnitureIcon.classList.add('icon-furniture');
      if (drawIcon) {
        drawIcon.classList.remove('icon-draw_mansion');
        drawIcon.classList.add('icon-draw');
      }
    } else {
      document.querySelector('.for2D .leftMenuCategories').classList.add('mansionMode');
      if ((<HTMLInputElement>document.querySelector('#select7'))) {
        (<HTMLInputElement>document.querySelector('#select7')).classList.add('isHidden');
        document.querySelector('#select7 + label').classList.add('isHidden');
      }
      (<HTMLInputElement>document.querySelector('#select6')).classList.add('isHidden');
      document.querySelector('#select6 + label').classList.add('isHidden');
      (<HTMLInputElement>document.querySelector('#select2')).classList.add('isHidden');
      document.querySelector('#select2 + label').classList.add('isHidden');
      (<HTMLInputElement>document.querySelector('#select0')).classList.add('isHidden');
      document.querySelector('#select0 + label').classList.add('isHidden');

      furnitureIcon.classList.remove('icon-furniture');
      furnitureIcon.classList.add('icon-furniture_mansion');
      if (drawIcon) {
        drawIcon.classList.remove('icon-draw');
        drawIcon.classList.add('icon-draw_mansion');
      }
    }
  }
}
